export function SiteFooter() {
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="wrap">
        <div className="call-row">
          <span>Prefer to talk to someone?</span>
          <a href="tel:1300931813">1300 931 813</a>
          <span style={{ color: 'var(--mute)' }}>Mon–Fri 8:30am–4:30pm AEST</span>
        </div>
        <div className="fine">
          © {new Date().getFullYear()} <b>Veteran Support Services Pty Ltd</b><br />
          This page is confidential to the person it was sent to.<br />
          This text came from Veteran Support Services.
        </div>
      </div>
    </footer>
  );
}
